<button
    type="button"
    class="print-container"
    [attr.aria-label]="'accessibility.print-location' | translate"
    (click)="printLocationInfo()"
>
    <span>{{ 'printLocation' | translate }}</span>
    <si-icon class="print-icon" icon="element-print" />
</button>
